export const AccountVerificationStatuses = {
  APPEALED: 'appealed',
  BLOCKED: 'blocked',
  NOT_SUSPENDED: 'notSuspended',
  SUSPENDED: 'suspended'
};